import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
 import api from "../actions/api"; 
export const fetchTimeSlotPopularity = createAsyncThunk(
  'timeSlot/fetchTimeSlotPopularity',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api({ auth: true }).get('/clinic/dashboard/appointments');
      return res.data.data.timeSlotPopularity || {};
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to fetch time slot popularity data');
    }
  }
);

const initialState = {
  timeSlotsData: {},
  loading: false,
  error: null,
};

const timeSlotSlice = createSlice({
  name: 'timeSlot',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchTimeSlotPopularity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTimeSlotPopularity.fulfilled, (state, action) => {
        state.loading = false;
        state.timeSlotsData = action.payload || {};
      })
      .addCase(fetchTimeSlotPopularity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default timeSlotSlice.reducer;